import React from "react";

import {
  Bar,
  BarChart,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Scatter,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function compactChartProps(isCompact, fillHeight = false) {
  const compactXAxis = {
    angle: -35,
    textAnchor: "end",
    height: 56,
    interval: 0,
    tick: { fontSize: 10 },
    tickFormatter: (value) =>
      value ? String(value).replace("Semana - ", "Sem. ") : value,
  };

  if (fillHeight) {
    return {
      height: "100%",
      margin: isCompact
        ? { top: 8, right: 8, left: -8, bottom: 4 }
        : { top: 8, right: 8, left: 0, bottom: 8 },
      xAxis: isCompact ? compactXAxis : {},
    };
  }

  if (!isCompact) {
    return {
      height: 400,
      margin: { top: 5, right: 0, left: 0, bottom: 5 },
      xAxis: {},
    };
  }

  return {
    height: 280,
    margin: { top: 8, right: 8, left: -8, bottom: 4 },
    xAxis: compactXAxis,
  };
}

export const chartBar = (
  data,
  dataKeyX,
  dataKeyActual,
  dataKeyComparation,
  dataNameActual,
  dataNameComparation,
  tickCount,
  isCompact = false,
  fillHeight = false
) => {
  const chartProps = compactChartProps(isCompact, fillHeight);

  return (
    <ResponsiveContainer width="100%" height={chartProps.height}>
      <BarChart width={"100%"} height={300} data={data} margin={chartProps.margin}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyX} {...chartProps.xAxis} />
        <YAxis tickCount={tickCount} width={isCompact ? 32 : 60} />
        <Tooltip />
        <Bar dataKey={dataKeyActual} name={dataNameActual} fill="#14B8A6" />
        <Bar
          dataKey={dataKeyComparation}
          name={dataNameComparation}
          fill="#3B82F6"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export const chartBarOne = (
  data,
  dataKeyX,
  dataKeyActual,
  dataNameActual,
  tickCount,
  isCompact = false,
  fillHeight = false
) => {
  const chartProps = compactChartProps(isCompact, fillHeight);

  return (
    <ResponsiveContainer width="100%" height={chartProps.height}>
      <BarChart width={"100%"} height={300} data={data} margin={chartProps.margin}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyX} {...chartProps.xAxis} />
        <YAxis tickCount={tickCount} width={isCompact ? 32 : 60} />
        <Tooltip />
        <Bar dataKey={dataKeyActual} name={dataNameActual} fill="#14B8A6" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export const chartThreeBar = (
  data,
  dataKeyX,
  dataKeyActual,
  dataKeyComparation,
  dataKeyActualComp,
  dataNameActual,
  dataNameActualComp,
  dataNameComparation,
  tickCount,
  content,
  isCompact = false
) => {
  const chartProps = compactChartProps(isCompact);

  return (
    <ResponsiveContainer width="100%" height={chartProps.height}>
      <BarChart width={"100%"} height={300} data={data} margin={chartProps.margin}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyX} {...chartProps.xAxis} />
        <YAxis tickCount={tickCount} width={isCompact ? 32 : 60} />
        {content ? <Tooltip content={content} /> : <Tooltip />}
        <Bar dataKey={dataKeyActual} name={dataNameActual} fill="#14B8A6" />
        <Bar
          dataKey={dataKeyComparation}
          name={dataNameComparation}
          fill="#3B82F6"
        />
        <Bar
          dataKey={dataKeyActualComp}
          name={dataNameActualComp}
          fill="#acb52d"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export const chartLinerDot = (
  data,
  dataKeyX,
  dataKeyActual,
  dataKeyComparation,
  dataNameActual,
  dataNameComparation,
  tickCount,
  isCompact = false,
  fillHeight = false
) => {
  const chartProps = compactChartProps(isCompact, fillHeight);

  return (
    <ResponsiveContainer width="100%" height={chartProps.height}>
      <ComposedChart
        width={"100%"}
        height={300}
        data={data}
        margin={chartProps.margin}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyX} {...chartProps.xAxis} />
        <YAxis tickCount={tickCount} width={isCompact ? 32 : 60} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey={dataKeyComparation}
          name={dataNameComparation}
          stroke="#14B8A6"
        />
        <Scatter fill="#3B82F6" dataKey={dataKeyActual} name={dataNameActual} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export const chartBarOneLine = (
  data,
  dataKeyX,
  dataKeyActual,
  dataNameActual,
  dataKeyComparation,
  dataNameComparation,
  tickCount,
  isCompact = false,
  fillHeight = false
) => {
  const chartProps = compactChartProps(isCompact, fillHeight);

  return (
    <ResponsiveContainer width="100%" height={chartProps.height}>
      <ComposedChart
        width={"100%"}
        height={300}
        data={data}
        margin={chartProps.margin}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyX} {...chartProps.xAxis} />
        <YAxis tickCount={tickCount} width={isCompact ? 32 : 60} />
        <Tooltip />
        <Bar dataKey={dataKeyActual} name={dataNameActual} fill="#3B82F6" />
        <Line
          type="monotone"
          dataKey={dataKeyComparation}
          name={dataNameComparation}
          stroke="#EC6D62"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
